import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@/UI/Components/Typography/Typography';
import { ChevronRight, Menu, X, MessageCircle } from 'react-feather';
import Modal from '@/UI/Components/Modal/Modal';

const Navbar = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

	const APP_STORE_URL = 'https://apps.apple.com/6475484002';
	const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.finclu.app';

	const handleDownloadClick = () => {
		const userAgent = navigator.userAgent.toLowerCase();
		const isIOS = /iphone|ipad|ipod/.test(userAgent);
		const isAndroid = /android/.test(userAgent);
		if (isIOS) {
			window.open(APP_STORE_URL, '_blank');
		} else if (isAndroid) {
			window.open(PLAY_STORE_URL, '_blank');
		} else {
			setIsDownloadModalOpen(true);
		}
	};

	const handleStoreSelect = (url: string) => {
		window.open(url, '_blank');
		setIsDownloadModalOpen(false);
	};

	return (
		<>
			<div className="flex flex-row justify-center items-center bg-gradient-to-r from-[#4660ff] to-[#5a75ff] sticky top-0 z-30 shadow-lg backdrop-blur-sm">
				<div className="flex flex-row w-full md:w-4/5 px-4 md:px-6 py-4 md:py-6 items-center">
					<div className="flex flex-row gap-8 grow">
						<div className="flex flex-col gap-2 cursor-pointer w-32 md:w-36 transition-transform duration-300 hover:scale-105">
							<Link to="/">
								<img src="/logo.svg" alt="Fincluyente" className="h-8 md:h-10" />
							</Link>
						</div>
					</div>

					<div className="md:hidden">
						<button
							onClick={() => setIsMenuOpen(true)}
							className="p-2 rounded-lg hover:bg-white/10 transition-colors duration-200"
						>
							<Menu className="h-6 w-6 text-white" />
						</button>
					</div>

					<div className="hidden md:flex flex-row gap-3 items-center">
						<a
							className="py-2 px-6 rounded-full flex flex-row gap-2 items-center bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white/20 transition-all duration-300 hover:scale-105"
							target="_blank"
							href={`https://wa.me/+525625466550?text=${encodeURIComponent('Hola Finclu!')}`}
						>
							<MessageCircle className="w-4 h-4" />
							<Typography size={14} weight="medium" color="white">
								Habla con Finclu
							</Typography>
							<ChevronRight className="w-4 h-4" />
						</a>
						<div className="bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 p-0.5">
							<button
								onClick={handleDownloadClick}
								className="bg-white hover:bg-gray-50 transition-colors py-2 px-6 rounded-full flex flex-row gap-2 items-center shadow-sm"
							>
								<Typography size={14} weight="semibold" color="black">
									Descarga la App
								</Typography>
								<ChevronRight className="w-4 h-4 text-[#4660ff]" />
							</button>
						</div>
					</div>
				</div>
			</div>

			<div
				className={`z-40 fixed inset-y-0 right-0 w-80 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out ${
					isMenuOpen ? 'translate-x-0' : 'translate-x-full'
				}`}
			>
				<div className="p-6 h-full flex flex-col">
					<div className="flex justify-between items-center mb-8">
						<div className="w-32">
							<img src="/black-logo.png" alt="Fincluyente" />
						</div>
						<button
							onClick={() => setIsMenuOpen(false)}
							className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
						>
							<X className="h-6 w-6 text-gray-700" />
						</button>
					</div>

					<div className="flex flex-col gap-2 flex-1">
						<div
							className="hover:bg-blue-50 rounded-xl p-4 cursor-pointer transition-all duration-200 border border-transparent hover:border-blue-100"
							onClick={() => setIsMenuOpen(false)}
						>
							<Typography size={16} weight="semibold" color="black">
								Descarga la App
							</Typography>
						</div>
						<a
							className="hover:bg-blue-50 rounded-xl p-4 transition-all duration-200 border border-transparent hover:border-blue-100 flex items-center justify-between"
							target="_blank"
							href={`https://wa.me/+525625466550?text=${encodeURIComponent('Hola Finclu!')}`}
							onClick={() => setIsMenuOpen(false)}
						>
							<Typography size={16} weight="semibold" color="black">
								Habla con Finclu
							</Typography>
							<ChevronRight className="w-5 h-5 text-gray-600" />
						</a>
					</div>
				</div>
			</div>

			{isMenuOpen && (
				<div
					className="fixed inset-0 bg-black bg-opacity-50 z-30 backdrop-blur-sm transition-opacity duration-300"
					onClick={() => setIsMenuOpen(false)}
				/>
			)}

			<Modal isOpen={isDownloadModalOpen} closeable onClose={() => setIsDownloadModalOpen(false)}>
				<div className="flex flex-col gap-4 p-6">
					<Typography size={18} weight="bold">
						Descarga la App
					</Typography>
					<Typography size={14}>Por favor selecciona tu tienda de aplicaciones.</Typography>
					<div className="flex flex-row gap-8 justify-center">
						<div
							className="flex w-1/3 cursor-pointer"
							onClick={() => handleStoreSelect(APP_STORE_URL)}
						>
							<img src="/appstore-logo.png" alt="disponible-en-appstore" />
						</div>
						<div
							className="flex w-1/3 cursor-pointer"
							onClick={() => handleStoreSelect(PLAY_STORE_URL)}
						>
							<img src="/google-play-logo.svg" alt="disponible-en-google-play" />
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
};
export default Navbar;
